"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doesWordMatchRegex = doesWordMatchRegex;
exports.searchAndReplaceWithRegex = searchAndReplaceWithRegex;
exports.applyAllReplacements = applyAllReplacements;
/**
 * Checks whether a word is matched with a regex.
 *
 * @param {string} word		The word to check.
 * @param {string} regex	The regex.
 * @returns {boolean}		Whether or not there was a match.
 */

function doesWordMatchRegex(word, regex) {
  var regexObject = RegExp(regex);
  return regexObject.test(word);
}
/**
 * Loops through a nested array with pairs of regexes and replacements, and performs the needed replacement if a match is found.
 *
 * @param {string} word 							The word that may need to be modified.
 * @param {[][]} groupOfRegexAndReplacements 	The array with the regexes and the required replacements.
 * @returns {?string} The modified stem or null if no match was found.
 */


function searchAndReplaceWithRegex(word, groupOfRegexAndReplacements) {
  var _iterator = _createForOfIteratorHelper(groupOfRegexAndReplacements),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var regexAndReplacement = _step.value;

      if (word.search(new RegExp(regexAndReplacement[0])) !== -1) {
        word = word.replace(new RegExp(regexAndReplacement[0]), regexAndReplacement[1]);
        return word;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/**
 * Loops through a nested array of regexes and replacement pairs, and applies all replacements for which a match is found.
 *
 * @param {string}      word                        The word that may need to be modified.
 * @param {string[]}    listOfRegexAndReplacement   The array with the regexes and the replacements.
 *
 * @returns {string} The modified word.
 */


function applyAllReplacements(word, listOfRegexAndReplacement) {
  listOfRegexAndReplacement.forEach(function (setOfRegexAndReplacement) {
    word = word.replace(new RegExp(setOfRegexAndReplacement[0]), setOfRegexAndReplacement[1]);
  });
  return word;
}